import { useFlexLayout, useTable } from 'react-table';

import { ReactTableWrapper } from 'ui-components/components/react-table-wrapper/react-table-wrapper';

import { useImportContext } from '../import-context';
import { createArrowColumnDefinition } from './arrow-column/arrow-column';
import { createCsvHeaderColumnDefinition } from './csv-header-column/csv-header-column';
import { createPreviewDataColumnDefinition } from './preview-data-column/preview-data-column';
import { createShipstationFieldColumnDefinition } from './shipstation-field-column/shipstation-field-column';
import styles from './styles.module.less';

const columns = [
  createShipstationFieldColumnDefinition(),
  createArrowColumnDefinition(),
  createCsvHeaderColumnDefinition(),
  createPreviewDataColumnDefinition(),
];

export const MappingTable = () => {
  const { definition } = useImportContext();

  const data = definition.attributes;

  const { getTableProps, headerGroups, getTableBodyProps, rows, prepareRow } = useTable(
    {
      columns,
      data,
    },
    useFlexLayout,
  );

  return (
    <ReactTableWrapper
      className={styles['table-body']}
      getTableBodyProps={getTableBodyProps}
      getTableProps={getTableProps}
      headerGroups={headerGroups}
      headerRowClassName={styles['table-column-header']}
      prepareRow={prepareRow}
      rows={rows}
    />
  );
};
